import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import {
    LegacyCityPropType,
    MessagePropType,
    Config,
} from '@ratehub/base-ui';

import LandTransferTaxStepInputs from './LandTransferTaxStepInputs';
import MortgageCalculator from './MortgageCalculator';


function LandTransferTaxCalculator({
    initialProvinceCode,
    initialCity,
    initialAskingPrice,

    messageBannerTitle,
    messageBannerDescription,
    ctaHref,
    ctaLabel,

    isProductReferralDisabled,

    ...otherProps
}) {
    return (
        <MortgageCalculator
            title={(
                <FormattedMessage
                    id="mtg-calculator.LandTransferTax.calculatorTitle"
                    defaultMessage="Ratehub.ca's land transfer tax calculator"
                />
            )}
            onSaveDocument={saveFormData}
            isSaveEnabled={Config.ENABLE_SAVING_DATA_FOR_CALCULATORS}
            {...otherProps}
        >
            <LandTransferTaxStepInputs
                stepNumber={1}

                initialProvinceCode={initialProvinceCode}
                initialCity={initialCity}
                initialAskingPrice={initialAskingPrice}

                messageBannerTitle={messageBannerTitle}
                messageBannerDescription={messageBannerDescription}
                ctaHref={ctaHref}
                ctaLabel={ctaLabel}

                isProductReferralDisabled={isProductReferralDisabled}
            />
        </MortgageCalculator>
    );
}

function saveFormData(document, values) {
    document?.journey?.update({
        calculators: {
            property: {
                homeValue: parseInt(values.askingPrice),
                address: {
                    city: values?.location?.name,
                    province: values?.location?.province?.code,
                },
            },
            firstTimeHomeBuyer: values.isFirstTimeHomeBuyer,
        },
    });
}

LandTransferTaxCalculator.propTypes = {
    initialProvinceCode: PropTypes.string,
    initialCity: LegacyCityPropType,
    initialAskingPrice: PropTypes.number,

    messageBannerTitle: MessagePropType,
    messageBannerDescription: MessagePropType,
    ctaHref: PropTypes.string,
    ctaLabel: PropTypes.string,

    isProductReferralDisabled: PropTypes.bool,
};

LandTransferTaxCalculator.defaultProps = {
    initialProvinceCode: undefined,
    initialCity: undefined,
    initialAskingPrice: undefined,

    messageBannerTitle: undefined,
    messageBannerDescription: undefined,
    ctaHref: undefined,
    ctaLabel: undefined,

    isProductReferralDisabled: false,
};

export default observer(LandTransferTaxCalculator);
